import { supabase } from "../lib/supabase";

/**
 * A valid login with no membership lands here. This is also what an intruder
 * with working credentials sees, which is the point: access comes from an
 * invitation, never from signing up.
 */
export function NoAccess({ email }: { email?: string }) {
  return (
    <main className="auth">
      <div className="card">
        <h1>No company yet</h1>
        <p className="muted">
          You are signed in{email ? ` as ${email}` : ""}, but you have not been added to a
          company. Ask whoever runs your account to send you an invitation.
        </p>
        <button className="btn ghost" onClick={() => void supabase.auth.signOut()}>
          Sign out
        </button>
      </div>
    </main>
  );
}
